/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const pencil = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="m19 7-3-3-8.5 8.5-1 4 4-1L19 7Zm-7 11.5H5V20h7v-1.5Z" />
	</SVG>
);

export default pencil;
